// Modules / classes
import Search from "./modules/search";

// Instantiate a new object using modules/classes
document.addEventListener("DOMContentLoaded", () => {
  // Only boot if the Articles controls + input exist
  if (document.querySelector(".articles-controls #search")) {
    new Search();
  }
});